/**
 * Checks if the values are either null or undefined.
 */
export const isNullOrUndefined = (...values) => values.every((value) => value === null || value === undefined);

export const isEmptyArray = (arr) => Array.isArray(arr) && arr.length === 0;

export const findRule = (errorBag, rule) => errorBag.find((e) => e.rule === rule);

export const getNested = (theObject, path, _separator) => {
  try {
    const separator = _separator || '.';

    return path
      .replace('[', separator)
      .replace(']', '')
      .split(separator)
      .reduce((obj, property) => obj[property], theObject);
  } catch (err) {
    return undefined;
  }
};

/**
 * Checks an object or array if it is empty returns true if it is.
 */
// export const isEmpty = (obj) => {
//   for (const key in obj) {
//     if (obj.hasOwnProperty(key)) { return false; }
//   }
//   return true;
// };

export const isEmpty = (obj) => {
	if(Array.isArray(obj)) {
		return !obj.length > 0;
	} else {
		if(obj && Object.keys(obj).length === 0 && Object.getPrototypeOf(obj) === Object.prototype) {
      return true;
		} else {
      return false;
		}
	}
}

export const isArrayOrObject = (obj) => typeof (obj) === 'object' && obj !== null;
